import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import CheckoutPage from './CheckoutPage';
import { cartActions } from '../../_actions';

const getCartItems = (cart) => {
  if (cart?.items && Array.isArray(cart.items)) {
    return cart.items;
  }

  if (cart?.list) {
    if (Array.isArray(cart.list.all)) {
      return cart.list.all;
    }

    const mainWarehouse = cart.list.main_warehouse || [];
    const onRequest = cart.list.on_request || [];
    const notFound = cart.list.not_found_in_price || [];
    return [...mainWarehouse, ...onRequest, ...notFound];
  }

  return [];
};

/**
 * Checkout контейнер
 * Логіка:
 * - Якщо користувач залогінений → редирект на /cart (попап оформлення)
 * - Якщо кошик пустий → редирект на /cart
 * - Інакше → показати CheckoutPage
 */
const Checkout = ({ authentication, cart, getCart }) => {
  useEffect(() => {
    if (!cart?.list && !cart?.loading) {
      getCart();
    }
  }, [cart, getCart]);

  const cartItems = getCartItems(cart);

  // Якщо користувач залогінений, редирект на /cart (попап логіка)
  if (authentication?.loggedIn) {
    return <Redirect to="/cart" />;
  }

  // Якщо корзина ще не завантажена, чекаємо заповнення
  if (
    cartItems.length === 0 &&
    !cart?.loading &&
    cart?.list === undefined &&
    cart?.items === undefined
  ) {
    return null;
  }

  // Поки йде завантаження корзини, не редіректимо
  if (cart?.loading) {
    return null;
  }

  // Якщо кошик пустий або нема товарів
  if (cartItems.length === 0) {
    return <Redirect to="/cart" />;
  }

  return <CheckoutPage />;
};

const mapStateToProps = (state) => ({
  authentication: state.authentication,
  cart: state.cart,
});

const mapDispatchToProps = {
  getCart: cartActions.getCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
